import type { CatItem } from './batch';
import { catUrl } from './filterUrl';
import { state } from './state';

const SITE = 'https://imagecat.ru';

export function shareUrlForCat(c: CatItem): string {
  if (c.publicId) {
    return `${SITE}/i/${c.publicId}`;
  }
  const base = catUrl(state.filter);
  const path = new URL(base, SITE).pathname;
  return `${SITE}${path}?photo=${encodeURIComponent(c.url)}`;
}

export async function copyShareLink(c: CatItem): Promise<boolean> {
  const text = shareUrlForCat(c);
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // fallback below
  }
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.style.position = 'fixed';
  ta.style.left = '-9999px';
  document.body.appendChild(ta);
  ta.select();
  const ok = document.execCommand('copy');
  ta.remove();
  return ok;
}

export function openImageUrl(url: string): void {
  window.open(url, '_blank', 'noopener,noreferrer');
}

export function parsePhotoFromQuery(): string | null {
  const photo = new URLSearchParams(location.search).get('photo');
  return photo && photo.startsWith('http') ? photo : null;
}

export function parsePermalinkId(pathname: string): string | null {
  const m = pathname.match(/^\/i\/([a-z0-9]{6,32})$/i);
  return m ? m[1].toLowerCase() : null;
}
